module.exports = require('./helpers/bundle-url').getBundleURL('dHWTq') + "logo.c5857b8b.svg";